export default {
  heroTitle: '郝海东',
  heroSubtitle: '中国足球传奇前锋',
  heroDescription: '96粒顶级联赛进球 · 107场国家队出战 · 18年职业生涯 · 中国足球史上最具标志性的前锋',
  sectionStats: '核心数据',
  sectionCategories: '探索分类',
  sectionFeatured: '精选文章',
  sectionTimeline: '生涯时间线',
  sectionHonors: '荣誉殿堂',
  viewAllArticles: '查看全部文章',
  readMore: '阅读全文',
  teamHonorsTitle: '团队荣誉',
  personalHonorsTitle: '个人荣誉',
  ctaTitle: '深入了解郝海东的传奇故事',
  ctaDescription: '浏览更多关于郝海东的进球纪录、国家队生涯、俱乐部岁月和争议事件的深度文章。',
  ctaButton: '浏览全部文章',
};